import api from './api';

const coursesService = {
  getStores: async (params = {}) => {
    const response = await api.get('/courses/stores', { params });
    return response.data;
  },

  getStore: async (id) => {
    const response = await api.get(`/courses/stores/${id}`);
    return response.data;
  },

  createOrder: async (orderData) => {
    const response = await api.post('/courses/orders', orderData);
    return response.data;
  },

  getMyOrders: async () => {
    const response = await api.get('/courses/orders/my-orders');
    return response.data;
  },

  getOrder: async (id) => {
    const response = await api.get(`/courses/orders/${id}`);
    return response.data;
  },

  cancelOrder: async (id, notes) => {
    const response = await api.put(`/courses/orders/${id}/cancel`, { notes });
    return response.data;
  },
};

export default coursesService;
